module.exports = __webpack_public_path__ + "media/images/bg-voo-d6e9e52fab8d58fb40bd4c6d6ed4590c.jpg";